export function handleMenuKeydown(event: KeyboardEvent, items: readonly HTMLElement[]): boolean {
  if (!items.length) {
    return false;
  }

  const currentIndex = items.indexOf(event.target as HTMLElement);
  let nextIndex: number;

  switch (event.key) {
    case 'ArrowDown':
      nextIndex = currentIndex < items.length - 1 ? currentIndex + 1 : 0;
      break;
    case 'ArrowUp':
      nextIndex = currentIndex > 0 ? currentIndex - 1 : items.length - 1;
      break;
    case 'Home':
      nextIndex = 0;
      break;
    case 'End':
      nextIndex = items.length - 1;
      break;
    default:
      return false;
  }

  event.preventDefault();
  event.stopPropagation();
  items[nextIndex].focus();
  return true;
}
